import React from 'react';
import { Select, MenuItem, SelectChangeEvent } from '@mui/material';
import styles from '../AccreditationForm.module.scss';

type Player = { id: string; name: string };

type PlayersDropdownProps = {
  players: Player[];
  selectedPlayerId: string;
  onPlayerChange: (selectedPlayerId: string) => void;
};

export const PlayersDropdown = ({
  players,
  selectedPlayerId,
  onPlayerChange,
}: PlayersDropdownProps) => {
  const handleChange = (event: SelectChangeEvent<string>) => {
    onPlayerChange(event.target.value);
  };

  if (!players || players.length === 0) return null;

  return (
    <Select
      value={selectedPlayerId}
      onChange={handleChange}
      displayEmpty
      MenuProps={{
        MenuListProps: {
          className: styles.playersDropdownMenuList,
        },
      }}
      renderValue={selectedId => {
        const player = players.find(p => p.id === selectedId);
        return player ? player.name : '';
      }}
      className={styles.playersDropdown}
    >
      {players.map(player => (
        <MenuItem key={player.id} value={player.id}>
          {player.name}
        </MenuItem>
      ))}
    </Select>
  );
};
